export default __webpack_public_path__ + "static/media/select-bet-2.ce62170f.mp3";